<template>
	<div class="flex items-stretch justify-start">
		<div class="hidden sm:block lg:flex-shrink-0 bg-[#4f4c88] rounded-2xl">
			<img class="w-72 h-full object-cover" src="/img/code.svg" alt="Login" />
		</div>
		<div class="py-6 ml-3 flex flex-col justify-evenly">
			<div class="flex items-center px-5 md:px-9">
				<UserAvatar :avatar="userStore.user?.avatar" />
				<span class="flex flex-col justify-center items-start">
					<span
						class="ml-5 mt-3 md:text-2xl font-medium md:leading-6 text-color-standard"
						aria-hidden="true"
					>
						{{ firstName }}
					</span>
					<span
						class="ml-5 mt-3 md:text-lg md:leading-5 text-color-standard"
						aria-hidden="true"
					>
						{{ userStore.user?.login_session?.school_name }}
					</span>
				</span>
			</div>
			<div class="pt-6 flex space-y-10">
				<div class="px-5 md:px-9 text-left flex flex-col flex-grow">
					<div class="gap-2 md:gap-4 mb-5 md:mb-9">
						<LocaleSelector v-model="settings.locale" />
					</div>
				</div>
			</div>
			<div class="flex justify-between px-5 md:px-9 text-left">
				<div class="py-1 flex items-center justify-start text-left">
					<div>
						<p class="text-sm pr-5 font-semibold text-gray-900 dark:text-[#E8E8F4]">
							Dark Mode:
						</p>
					</div>
					<DarkModeToggle class="flex items-center" />
				</div>
				<div class="flex justify-center">
					<AppSavingIndicator :saving="saving" />
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { watchDebounced } from '@vueuse/core';
import { computed, reactive, ref } from 'vue';

import AppSavingIndicator from '@/components/ui/AppSavingIndicator.vue';
import DarkModeToggle from '@/components/ui/DarkModeToggle.vue';
import LocaleSelector from '@/components/ui/LocaleSelector.vue';
import UserAvatar from '@/components/ui/UserAvatar.vue';
import { useUserStore } from '@/stores/user';
import { Settings } from '@/types';

const userStore = useUserStore();

const firstName = computed(() => userStore.user?.name.split(' ')[0]);

const settings = reactive<Settings>({
	locale: userStore.settings.locale,
});

const saving = ref(false);

watchDebounced(
	() => settings,
	settings => {
		saving.value = true;
		userStore.saveSettings(settings).then(() => (saving.value = false));
	},
	{ debounce: 500, deep: true },
);
</script>
